import React, { Fragment, useEffect, useState, forwardRef, useRef } from 'react'
import * as R from 'ramda'
import G from '../../../../../../util/globalFunction'
import tremApi, { nullCheckParameter, nullExceptParameter } from '../../../../../../util/tremApi'
import tremSession from '../../../../../../util/tremSession'

import 'jspdf-autotable'
import html2canvas from 'html2canvas'
import EquipMro from '../detailSub/component/equipMro'
import EquipUseMethod from './component/equipUseMethod'
import EquipOperSp from './component/equipOperSp'
import ModalBox, { usePopup } from '../../../../../../components/modalBox'
import PopupEstimatePrint from '../popup/popupEstimatePrint'
import PopupEstimateRequest from '../popup/popupEstimateRequest'
import PopupUserSelect from '../../../../component/popup/popupUserSelect'
import PopupDeptSelect from '../../../../component/popup/popupDeptSelect'
import { setPrintCount, createPdfFormHtml } from '../../../../../../util/tremDocument'
import { serverUrl, serverPrefixUrl } from '../../../../../../config'
import TF from '../../../../../../util/tremFunction'
import Cookies from 'js-cookie'


export default props => {
    const { setTabMenu, params } = props

    const mobileNumRef = useRef(null);
    const emailRef = useRef(null);

    useEffect(async () => {
        if (params?.EQUIP_SKEY) {
            const userSkey = await tremSession.getUserSkey()

            if(R.isNil(userSkey)){
                alert(G.t('trem.lang.home.0697'), G.t('trem.lang.home.1137'), ()=>{G.gotoPage('/login')})    /* 로그인 후 이용가능합니다. */
            }else{
                getReservDetail(
                    userSkey,
                    params.EQUIP_SKEY,
                    params.OPER_LIST[0].OPER_SKEY,
                    params.FIR_CM_SCH_SKEY
                )
            }
        }
    }, [params])

    const [dataStore, setDataStore] = useState({
        reservData: {
            //장비예약 정보
            equipMstr: {},
            requesterUserInfo: {},
            equipOperInfo: {},
            equipOperSpList: [],
            discountList: [],
            penaltyList: [],
            mroSubList: [],
            mroOptSubList: [],
            eduList: [],
            managerFlag: false,
        },
        paramData: {}, //파라미터 풀
    })

    //요약팝업 데이터
    const [chargeData, setChargeData] = useState({
        CHARGE_LIST: [],
        AMOUNT: 0,
    })
    const CHARGE_LIST  = chargeData?.CHARGE_LIST

    const { reservData, paramData } = dataStore
    let {
        equipMstr,
        requesterUserInfo,
        equipOperInfo,
        equipOperSpList,
        discountList,
        penaltyList,
        mroSubList,
        mroOptSubList,
        eduList,
        managerFlag,
    } = reservData
    /*
        유저 정보
        유저 권한 정보
        특수예약 리스트
        할인정책 리스트
        패널티정책 리스트
        선착순 리스트
        실험재료 리스트
        부가서비스 리스트
        교육병행 교육정보 리스트
        장비담당자(관리자) 정보
    */
    //예약 정보 가져오기(처음, 예약옵션 바뀔때, 선착순옵션 바뀔때)
    const getReservDetail = (USER_SKEY, EQUIP_SKEY, OPER_SKEY, FIR_CM_SCH_SKEY = '') => {
        let searchParams = { USER_SKEY, EQUIP_SKEY, OPER_SKEY, FIR_CM_SCH_SKEY }

        tremApi('/r/hm/equipReservation/detail/reserv', searchParams)
            .then(data => {
                const timeUnit = data.equipOperInfo.TIME_UNIT
                const bookingType =
                    data.equipOperInfo.FLAG_SELF_USE != 'N'
                        ? 'SU'
                        : data.equipOperInfo.FLAG_EXPERT == 'Y'
                        ? 'EX'
                        : data.equipOperInfo.FLAG_REQ != 'N'
                        ? 'RE'
                        : data.equipOperInfo.FLAG_WITH_EDU != 'N' &&
                          data.eduList &&
                          data.eduList.length > 0
                        ? 'WE'
                        : ''

                const timeUnitRepeat =
                    timeUnit === '10' ? 10 : timeUnit === '15' ? 15 : timeUnit === '0.5' ? 30 : 1

                //초기값 세팅
                let initData = {
                    EQUIP_SKEY: data.equipMstr.EQUIP_SKEY,
                    OPER_SKEY: data.equipOperInfo.OPER_SKEY,
                    REQUESTER_SKEY: data.requesterUserInfo.USER_SKEY,
                    REQUESTER_AUTH: data.requesterUserInfo.AUTH_TYPE,
                    TIME_UNIT: data.equipOperInfo.TIME_UNIT,
                    COMPANY_SKEY: data.requesterUserInfo.CDTYPE_SKEY,
                    COMPANY_TYPE: data.requesterUserInfo.CDTYPE_INOUT,
                    COMPANY_NAME: data.requesterUserInfo.CDTYPE_NAME,
                    QUENTITY: data.equipOperInfo.DEFAULT_QUENTITY || 0,
                    REPEAT_COUNT: data.equipOperInfo.DEFAULT_REPEAT || 0,
                    REPEAT_AREA_COUNT: 0,
                    TIME_UNIT_REPEAT: timeUnitRepeat,
                    minTimeUnit: data.equipOperInfo.MIN_TIME_UNIT || 1,
                    maxTimeUnit: data.equipOperInfo.MAX_TIME_UNIT || 1,
                    BOOKING_TYPE: bookingType,
                    UA_EDU_SKEY: '',
                    OPT_MRO_LIST: data.mroOptSubList.map(obj => {
                        return { MRO_SKEY: obj.MRO_SKEY, QUENTITY: obj.BASE_QUENTITY }
                    }),
                    MRO_LIST: data.mroSubList.map(obj => {
                        return { MRO_SKEY: obj.MRO_SKEY, QUENTITY: obj.BASE_QUENTITY }
                    }),
                }
                nullCheckParameter(initData)
                setDataStore({
                    ...dataStore,
                    reservData: { ...data },
                    paramData: { ...paramData, ...initData },
                })
                setEstimateChargeList(initData)
            })
            .catch(err => {
                alert(G.t('trem.lang.home.0836'), err)/* 오류발생 */
            })
    }

    //값 변경
    const handleChangeData = (e, i) => {
        const param = { ...paramData }
        if (e.target.type === 'checkbox') {
            e.target.checked ? (param[e.target.name] = 'Y') : (param[e.target.name] = 'N')
        } else if (e.target.className === 'OPT_MRO_LIST') {
            let OPT_MRO_LIST = paramData.OPT_MRO_LIST
            OPT_MRO_LIST[i].QUENTITY = e.target.value
            param['OPT_MRO_LIST'] = OPT_MRO_LIST
        } else if (e.target.className === 'MRO_LIST') {
            let MRO_LIST = paramData.MRO_LIST
            MRO_LIST[i].QUENTITY = e.target.value
            param['MRO_LIST'] = MRO_LIST
        } else {
            param[e.target.name] = e.target.value
            if (e.target.name === 'BOOKING_TYPE') {
                e.target.value != 'WE' && e.target.value != 'WU'
                    ? (param['UA_EDU_SKEY'] = '')
                    : e.target.value != 'EX'
                    ? (param['EXPERT_SKEY'] = '')
                    : null
            }
        }
        setDataStore({ ...dataStore, paramData: param })
        setEstimateChargeList(param)
    }

    const setEstimateChargeList = paramObj => {
        const param = getEstimateParam(paramObj)

        tremApi('/r/hm/equipReservation/reservation/getData', nullCheckParameter(param))
            .then(obj => {          
                setChargeData(obj)
            })
            .catch(err => {
                alert(`${G.t('trem.lang.home.0836')}2`, err) //오류발생2
            })
    }

    const getEstimateParam = paramObj => {
        const timeUnit = paramObj.TIME_UNIT
        const timeUnitRepeat =
            timeUnit === '30' || timeUnit === '60'
                ? paramObj.TIME_UNIT_REPEAT * 60
                : paramObj.TIME_UNIT_REPEAT

        let param = {
            EQUIP_SKEY: paramObj.EQUIP_SKEY,
            OPER_SKEY: paramObj.OPER_SKEY,
            TIME_UNIT_REPEAT: timeUnitRepeat,
            REQUESTER_SKEY: paramObj.REQUESTER_SKEY,
            REQUESTER_AUTH: paramObj.REQUESTER_AUTH,
            COMPANY_SKEY: paramObj.COMPANY_SKEY,
            COMPANY_TYPE: paramObj.COMPANY_TYPE,
            REPEAT_AREA_COUNT: paramObj.REPEAT_AREA_COUNT,
            REPEAT_COUNT: paramObj.REPEAT_COUNT,
            QUENTITY: paramObj.QUENTITY,
            BOOKING_TYPE: paramObj.BOOKING_TYPE,
            UA_EDU_SKEY: paramObj.UA_EDU_SKEY,
        }

        paramObj.OPT_MRO_LIST.map((obj, index) => {
            param[`OPT_MRO_LIST[${index}].MRO_SKEY`] = obj.MRO_SKEY
            param[`OPT_MRO_LIST[${index}].QUENTITY`] = obj.QUENTITY
        })
        paramObj.MRO_LIST.map((obj, index) => {
            param[`MRO_LIST[${index}].MRO_SKEY`] = obj.MRO_SKEY
            param[`MRO_LIST[${index}].QUENTITY`] = obj.QUENTITY
        })

        //특수예약일때
        equipOperSpList.length > 0 &&
            spChkData.map((obj, index) => {
                param[`SP_LIST[${index}].OPER_SP_SKEY`] = obj.OPER_SP_SKEY
                param[`SP_LIST[${index}].RESERV_AREA_NO`] = obj.RESERV_AREA_NO
            })

        return param
    }

    //소속정보 입력 팝업
    const companyCheckPopupProps = usePopup('알림')
    const companyCheckPopupButtons = [
       {
           title:'등록하기',
           handler:()=>{
               G.gotoPage("/home/collabi/myPage/user/info")
           }
       }
    ]

    const estimateValidate = flag_msg => {
        
        if (!requesterUserInfo.USER_SKEY) {
            flag_msg && alert(G.t('trem.lang.home.0768')) //예약자 정보가 없습니다.
            return false
        }

        if (!paramData.COMPANY_SKEY) {
            //flag_msg && alert(G.t('trem.lang.home.0769')) //계산서 정보가 없습니다.
            flag_msg && companyCheckPopupProps.setOpen(true)
            return false
        }

        if (!paramData.TIME_UNIT_REPEAT) {
            flag_msg && alert(G.t('trem.lang.home.0770')) //총 활용시간을 입력해주세요.
            return false
        }

        if (!paramData.BOOKING_TYPE) {
            flag_msg && alert(G.t('trem.lang.home.0771')) // 예약방법을 선택해주세요.
            return false
        }
        if (
            (paramData.BOOKING_TYPE === 'WE' || paramData.BOOKING_TYPE === 'WU') &&
            !paramData.UA_EDU_SKEY
        ) {
            flag_msg && alert(G.t('trem.lang.home.0772')) //병행 교육을 선택해주세요.
            return false
        }

        if (equipOperSpList && equipOperSpList.length > 0) {
            if (spChkData.length < 1) {
                alert(G.t('trem.lang.home.0745')) //장비의 구간을 하나 이상 선택해주세요.
                return false
            }
        }

        return true
    }

    //가견적서 출력하기
    const requestEstimateFE = () => {
        if (estimateValidate(false)) {
            //if(confirm(G.t('trem.lang.home.0773'))){
            //G.confirm(G.t('trem.lang.home.0773')).then(success => { //가견적을 출력하시겠습니까?
            if(window.confirm(G.t('trem.lang.home.0773'))){
                    let param = getEstimateParam(paramData)
                    param['ESTIMATE_TYPE'] = 'FE'
                    param['STATUS'] = 'PT'

                    tremApi('/r/hm/equipEstimate/estimate/save', nullCheckParameter(param))
                        .then(obj => {
                            estimateFEPopupProps.setOpen(true, { ESTIMATE_SKEY: obj })
                        })
                        .catch(err => {
                            alert(G.t('trem.lang.home.0836')+'2', err)/* 오류발생2 */
                        })

            }
        }
    }

    // 이용중인 언어
    const currentLang = Cookies.get('__floor_lang__') || 'ko'

    const [click, setClick] = useState(false)
    const estimateFEPopupProps = usePopup('trem.lang.home.0774') // 가견적서 출력
    const EstimateFEPopup = popupProps => {
        const { open, handleClose, param } = popupProps

        const clickRef = useRef(null)
        let estimatePdfRef = useRef(null)

        const buttons = [
            {
                title: G.t('trem.lang.home.0775'), //인쇄
                className: 'red',
                handler: () => {
                    clickRef.current.handlePrint()
                    setClick(true)
                },
            },
            {
                title: G.t('trem.lang.home.0776'), //PDF출력
                className: 'red',
                handler: async () => {
                    const pdfRef = estimatePdfRef.current
                    const document= {
                        element:pdfRef, 
                        canvWidth:210, 
                        canvHeight:290, 
                        contentWidth:60, 
                        contentHeight:70, 
                        marginRight:10, 
                        marginLeft:20,
                        title:equipMstr?.KOR_NM
    
                    }
                    await createPdfFormHtml(document) // pdf 출력
                    setClick(true)
                    handleClose()
                },
            },
            {
                title: G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose,
            },
        ]
        // 인쇄, pdf 출력 서류 발행 현황개수 실행
        const getPopupValFn = obj => {
            click === true &&
                setPrintCount({
                    DOC_PRT_TYPE: 'ET',
                    DOC_PRT_NO: obj?.ESTIMATE_NO,
                    REF_SKEY: obj?.ESTIMATE_SKEY,
                    REF_NAME: obj?.EQUIP_NAME,
                    USER_SKEY: requesterUserInfo?.USER_SKEY,
                })
        }

        const estimatePrintProps = {
            clickRef,
            pdfRef:estimatePdfRef,
            param,
            click,
            getPopupValFn
        }
        return (
            open && (
                <ModalBox {...popupProps} buttons={buttons} width="800" height="600">
                    <PopupEstimatePrint {...estimatePrintProps} />
                </ModalBox>
            )
        )
    }

    //견적 요청하기
    const requestEstimateOE = () => {
        if (estimateValidate(true)) {
            let param = getEstimateParam(paramData)
            estimateOEPopupProps.setOpen(true)
        }
    }
    const estimateOEPopupProps = usePopup('trem.lang.home.0152')/* usePopup('견적 요청하기') */
    const EstimateOEPopup = popupProps => {
        const { open, handleClose } = popupProps
        const [popupData, setPopupData] = useState({
            REQUESTER_MOBILE_NO: requesterUserInfo.MOBILE_NO,
            REQUESTER_EMAIL: requesterUserInfo.EMAIL,
            REQURIEMENT: '',
        })

        const buttons = [
            {
                title: G.t('trem.lang.home.0462'),/* 요청 */
                className: 'red',
                handler: () => {
                    if (!popupData.REQUESTER_MOBILE_NO) {
                        alert(G.t('trem.lang.home.0777')) //연락처를 입력해주세요.
                        mobileNumRef.current.focus()
                        return false
                    }
                    if (!popupData.REQUESTER_EMAIL) {
                        alert(G.t('trem.lang.home.0778')) //이메일을 입력해주세요.
                        emailRef.current.focus()
                        return false
                    }
                    G.confirm(G.t('trem.lang.home.0779')).then(success => { //견적을 요청하시겠습니까?
                        if (success) {
                            let param = getEstimateParam(paramData)
                            param['ESTIMATE_TYPE'] = 'OE'
                            param['STATUS'] = 'PR'
                            param['REQUESTER_MOBILE_NO'] = popupData.REQUESTER_MOBILE_NO
                            param['REQUESTER_EMAIL'] = popupData.REQUESTER_EMAIL
                            param['REQURIEMENT'] = popupData.REQURIEMENT

                            tremApi('/r/hm/equipEstimate/estimate/save', nullCheckParameter(param))
                                .then(obj => {
                                    alert(G.t(G.t('trem.lang.home.0780')), '', () => { //견적이 신청되었습니다.
                                        if (equipMstr.completeActFlag) {
                                            setTabMenu(1)
                                        } else {
                                            G.gotoPage(`/home/equip/reserv/list`)
                                        }
                                        handleClose()
                                    })
                                })
                                .catch(err => {
                                    alert(G.t('trem.lang.home.0836')+'2', err)/* 오류발생2 */
                                })
                        }
                    })
                },
            },
            {
                title: G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose,
            },
        ]

        const estimateProps = {
            popupData,
            setPopupData,
            requesterUserInfo,
            mobileNumRef,
            emailRef
        }
        return (
            open && (
                <ModalBox {...popupProps} buttons={buttons} width="800" height="500">
                    <PopupEstimateRequest {...estimateProps} />
                </ModalBox>
            )
        )
    }

    // tab키로 이동
    const handleKeyPress = (e, i) =>{
        if(e.charCode === 13) { // enter
            //값 변경
            const param = { ...paramData }
            const targetEle = e.target.childNodes[0]
            if (targetEle.type === 'checkbox') {
                targetEle.checked ? (param[targetEle.name] = 'Y') : (param[targetEle.name] = 'N')
            } else if (targetEle.className === 'OPT_MRO_LIST') {
                let OPT_MRO_LIST = paramData.OPT_MRO_LIST
                OPT_MRO_LIST[i].QUENTITY = targetEle.value
                param['OPT_MRO_LIST'] = OPT_MRO_LIST
            } else if (targetEle.className === 'MRO_LIST') {
                let MRO_LIST = paramData.MRO_LIST
                MRO_LIST[i].QUENTITY = targetEle.value
                param['MRO_LIST'] = MRO_LIST
            } else {
                param[targetEle.name] = targetEle.value
                if (targetEle.name === 'BOOKING_TYPE') {
                    targetEle.value != 'WE' && targetEle.value != 'WU'
                        ? (param['UA_EDU_SKEY'] = '')
                        : targetEle.value != 'EX'
                        ? (param['EXPERT_SKEY'] = '')
                        : null
                }
            }
            setDataStore({ ...dataStore, paramData: param })
            setEstimateChargeList(param)
        }
    }

    //BOOING_TYPE radio button
    const InputBookingType = props => {
        const { val, nm } = props
        return (
            <div tabIndex={0} onChange={G.radioHandleClick} role="radio" onKeyPress={(e)=>handleKeyPress(e, handleChangeData)}>
                <input
                    type="radio"
                    title="예약유형 선택"
                    name="BOOKING_TYPE"
                    value={val}
                    id={'BOOKING_TYPE_' + val}
                    checked={val === paramData.BOOKING_TYPE}
                    onChange={handleChangeData}
                />
                <label htmlFor={'BOOKING_TYPE_' + val}>{nm}</label>
            </div>
        )
    }

    //예약자 변경
    const userPopupProps = usePopup('trem.lang.home.0734') //예약자 선택
    const UserPopup = popupProps => {
        const { open, handleClose } = popupProps

        let popupVal = {}

        const buttons = [
            {
                title: G.t('trem.lang.home.0200'),/* 선택 */
                className: 'red',
                handler: () => {
                    if (!popupVal.NAME) {
                        alert(G.t('trem.lang.home.0735')) /* 선택되지 않았습니다. */
                        return false
                    }
                    const userSkey = popupVal.USER_SKEY
                    getReservDetail(
                        userSkey,
                        equipMstr.EQUIP_SKEY,
                        equipOperInfo.OPER_SKEY,
                        equipMstr.FIR_CM_SCH_SKEY
                    )

                    handleClose()
                },
            },
            {
                title: G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose,
            },
        ]

        const getPopupValue = obj => {
            popupVal = obj
        }

        return (
            open && (
                <ModalBox {...popupProps} buttons={buttons}>
                    <PopupUserSelect getPopupValue={getPopupValue} />
                </ModalBox>
            )
        )
    }

    //소속(부서)변경
    const deptPopupProps = usePopup('trem.lang.home.0736') //거래처 선택
    const DeptPopup = popupProps => {
        const { open, handleClose } = popupProps

        let popupVal = {}

        const buttons = [
            {
                title: G.t('trem.lang.home.0200'),/* 선택 */
                className: 'red',
                handler: () => {
                    if (!popupVal.MASTER_SKEY) {
                        alert(G.t('trem.lang.home.0735')) /* 선택되지 않았습니다. */
                        return false
                    }
                    setDataStore({
                        ...dataStore,
                        paramData: {
                            ...paramData,
                            COMPANY_SKEY: popupVal.MASTER_SKEY,
                            COMPANY_TYPE: popupVal.MASTER_TYPE,
                            COMPANY_NAME: popupVal.MASTER_NAME,
                        },
                    })

                    handleClose()
                },
            },
            {
                title: G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose,
            },
        ]

        const getPopupValue = obj => {
            popupVal = obj
        }

        return (
            open && (
                <ModalBox {...popupProps} buttons={buttons}>
                    <PopupDeptSelect popupTitle = "client" getPopupValue={getPopupValue} />
                </ModalBox>
            )
        )
    }

    //특수예약 선택 구간
    const [spChkData, setSpChkData] = useState([])
    const fnSpChk = SP_LIST => {
        setSpChkData(SP_LIST)
        const param = { ...paramData }
        param['REPEAT_AREA_COUNT'] = SP_LIST.length
        setDataStore({ ...dataStore, paramData: param })
        setEstimateChargeList(param)
    }

    return (
        <Fragment>
            {/*Reserv Info 장비예약자정보*/}
            <div className="q_info">
            <h3 className='hidden'>{G.t('trem.lang.home.0021')}</h3>
                <ul>
                    <li>
                    <img alt={equipMstr.KOR_NM+" 사진"} src={R.isNil(equipMstr.PHOTO_FILE_SKEY) ? equipMstr.PHOTO_URL || serverUrl+serverPrefixUrl+"/resources/images/gist/common/no_image.jpg" : TF.getPhotoURL(equipMstr.PHOTO_FILE_SKEY) }/>                   
                    </li>
                    <li>
                        <p>{equipMstr.ENG_NM}</p>
                        <h3>
                            {equipMstr.KOR_NM}
                        </h3>
                        <a title="새창" href="javascript:void(0);" className="btn_help2" style={{top: '70px'}} onClick={() => { TF.goHelp("/hm/manual/equipEstimate")}}>
                            도움말
                        </a>
                        <dl>
                            <dt>{G.t('trem.lang.home.0049')}</dt>{/* 예약자 */}
                            <dd>
                                {requesterUserInfo.NAME}
                                {managerFlag && (
                                    <a href="javascript:void(0);"
                                        className="btn_modify"
                                        onClick={() => {
                                            userPopupProps.setOpen(true)
                                        }}
                                    >
                                        {G.t('trem.lang.home.0341')}
                                        {/* 수정 */}
                                    </a>
                                )}
                            </dd>
                            <dt>{G.t('trem.lang.home.0050')}</dt>{/* 연락처 */}
                            <dd>{requesterUserInfo.MOBILE_NO}</dd>
                            <dt>{G.t('trem.lang.home.0051')}</dt>{/* 계산서 */}
                            <dd>
                                {paramData?.COMPANY_NAME}
                                {managerFlag && (
                                    <a href="javascript:void(0);"
                                        className="btn_modify"
                                        onClick={() => {
                                            deptPopupProps.setOpen(true)
                                        }}
                                    >
                                        {G.t('trem.lang.home.0341')}
                                        {/* 수정 */}
                                    </a>
                                )}
                            </dd>
                        </dl>
                        <ul className="reser_use">
                            <li>
                                <h4>
                                    {G.t('trem.lang.home.0052')}{/* 이용권한 */}
                                    <br />
                                    <span>({requesterUserInfo.AUTH_TYPE_NAME})</span>
                                </h4>
                            </li>
                            <li>
                                <p tabIndex="0">
                                    {requesterUserInfo.AUTH_TERM_DAY ? (
                                        <b>
                                            {G.t('trem.lang.home.0752')}{' '} {/* 권한 만료 */}
                                            <span>{requesterUserInfo.AUTH_TERM_DAY}</span>{' '}
                                            {G.t('trem.lang.home.0545')}{' '}{/* 일 */}
                                            {G.t('trem.lang.home.0757')} {/* 병행교육선택 */}
                                        </b>
                                    ) : !requesterUserInfo.AUTH_TERM_DAY ||
                                      requesterUserInfo.UNLIMIT_AUTH_FLAG === 'Y' ? (
                                        <b>{G.t('trem.lang.home.0056')}</b>/* 권한 만료 기간 없음 */
                                    ) : (
                                        <b></b>
                                    )}
                                    <br />
                                    {G.t('trem.lang.home.0057')} {equipOperInfo.START_TIME}시 ~{' '}{/* 예약가능 시간은 ~~시 ~*/}
                                    {equipOperInfo.END_TIME}시 {G.t('trem.lang.home.0767')} {/* ~시 까지 가능합니다 */}
                                    <br />
                                    <span>{G.t('trem.lang.home.0058')}</span>{/* 토요일 일요일은 예약이 불가능 합니다. */}
                                    {equipOperInfo.FLAG_ALL_AUTH === 'Y'
                                        ? `* (${G.t('trem.lang.home.0754')})` // 직접이용시 예약가능 시간은 24시간 연중 무휴입니다.
                                        : ''}
                                    <br />
                                    {G.t('trem.lang.home.0059')}{/* 이용의뢰, 교육병행의뢰 예약은 운영자 업무시간에 한합니다. */}
                                    <br />
                                    {R.isNil(penaltyList)||discountList.length > 0 && '- ' + G.t('trem.lang.home.0060')}{/* 할인정책이 존재합니다. 예약전 확인해 주세요 */}
                                    <br />
                                    {R.isNil(penaltyList)||penaltyList.length > 0 && '- ' + G.t('trem.lang.home.0755')} {/* 패널티정책이 존재합니다. 예약전 확인해 주세요. */}
                                </p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div>
                <div className="e_option mb-6" role="group">
                    {params.OPER_LIST?.map((obj, index) => {
                        const selectOper = e => {
                            getReservDetail(
                                requesterUserInfo.USER_SKEY,
                                equipMstr.EQUIP_SKEY,
                                obj.OPER_SKEY,
                                equipMstr.FIR_CM_SCH_SKEY
                            )
                        }
                        return (
                            <Fragment key={index}>
                                <span tabIndex={0} aria-checked={obj.OPER_SKEY === equipOperInfo.OPER_SKEY} onChange={G.radioHandleClick} role="radio" onKeyPress = {(e)=> {e.code ==="Enter"? selectOper():""}}>
                                <input
                                    type="radio"
                                    title="예약옵션 선택"
                                    name="OPER_SKEY"
                                    id={'OPER_SKEY' + index}
                                    checked={obj.OPER_SKEY === equipOperInfo.OPER_SKEY}
                                    onChange={selectOper}
                                />
                                <label htmlFor={'OPER_SKEY' + index}>{currentLang === 'ko' ? obj.NAME : obj.NAME_ENG}</label>
                                </span>
                            </Fragment>
                        )
                    })}
                </div>

                {/*Method Tab 이용방법*/}
                <EquipUseMethod dataStore={dataStore} />

                <div className="e_method">
                    <h3 className="tt_type2">{G.t('trem.lang.home.0076')}</h3>{/* 장비예약 안내 */}
                    <p className="text_box3">
                        <span dangerouslySetInnerHTML={{ __html: equipOperInfo.RESERV_INFO }} />
                    </p>
                    <div className="step_box">
                        <div className="step_tt">
                            <h4>
                                <span>STEP 1</span>
                                {G.t('trem.lang.home.0061')}{/* 이용방법 */}
                            </h4>
                        </div>
                        {equipOperInfo?.CHARGE_TYPE != "05"&& equipOperInfo?.CHARGE_TYPE != "06"&&(
                            <div className="reserv_time">
                                <p className="notice2">
                                    <span className="info">!</span>
                                    현재 장비의 과금 기준은 (
                                    <span className="font-medium">
                                        <span
                                            className={
                                                equipOperInfo.CHARGE_TYPE === '01' ? 'text-red-500' : ''
                                            }
                                        >
                                            시간
                                        </span>
                                        ,
                                        <span
                                            className={
                                                equipOperInfo.CHARGE_TYPE === '02' ? 'text-red-500' : ''
                                            }
                                        >
                                            {' '}
                                            시료
                                        </span>
                                        ,
                                        <span
                                            className={
                                                equipOperInfo.CHARGE_TYPE === '03' ? 'text-red-500' : ''
                                            }
                                        >
                                            {' '}
                                            {G.t('trem.lang.home.0094')}{/* 시험횟수 */}
                                        </span>
                                    </span>
                                    ) 기준이며 기본 (
                                    <span className="font-medium">
                                        {equipOperInfo.TIME_UNIT === '1'
                                            ? equipOperInfo.TIME_UNIT * paramData.minTimeUnit + G.t('trem.lang.home.0545')/* 일 */
                                            : equipOperInfo.TIME_UNIT * paramData.minTimeUnit + '분'}
                                        {equipOperInfo.DEFAULT_QUENTITY > 0 &&
                                            ', ' + equipOperInfo.DEFAULT_QUENTITY + '시료'}
                                        {equipOperInfo.DEFAULT_REPEAT > 0 &&
                                            ', ' + equipOperInfo.DEFAULT_REPEAT + `${G.t('trem.lang.home.0094')}`}{/* , ~~시험횟수 */}
                                    </span>
                                    ) 입니다.
                                    <br />
                                    {G.t('trem.lang.home.0148')}
                                    {/* 자동으로 예약시간이 부여됩니다. 요약 과금과 최종 청구 금액이 다를 수 있습니다. */}
                                </p>
                            </div>
                        )}
                        <div className="reserv_time">
                            <ul>
                            {equipOperInfo?.CHARGE_TYPE != "05"&& equipOperInfo?.CHARGE_TYPE != "06"&&(
                                <Fragment>
                                    <li>
                                    <label htmlFor="TIME_UNIT_REPEAT">{G.t('trem.lang.home.0633')}</label>
                                        <input
                                            type="number"
                                            name="TIME_UNIT_REPEAT"
                                            id="TIME_UNIT_REPEAT"
                                            min="1"
                                            value={paramData.TIME_UNIT_REPEAT}
                                            onChange={handleChangeData}
                                            title={G.t('trem.lang.home.0089')}/* 총예약시간 */
                                            style={{ width: '60px' }}
                                        />
                                        {equipOperInfo.TIME_UNIT === '1'
                                            ? ' ' + G.t('trem.lang.home.0545')/* 일 */
                                            : equipOperInfo.TIME_UNIT > 1 &&
                                            equipOperInfo.TIME_UNIT < 30
                                            ? ' ' + G.t('trem.lang.home.0706') /* 분 */
                                            : ' ' + G.t('trem.lang.home.0090')}{/*  시간 */}
                                    </li>
                                
                                    <li>
                                    <label htmlFor="QUENTITY">{G.t('trem.lang.home.0093')}</label>{/* 시료수 */}
                                        <input
                                            title="시료수 입력"
                                            type="number"
                                            name="QUENTITY"
                                            id="QUENTITY"
                                            min="0"
                                            value={paramData.QUENTITY}
                                            onChange={handleChangeData}
                                            readOnly={
                                                equipOperInfo.CHARGE_TYPE === '01' ||
                                                equipOperInfo.CHARGE_TYPE === '03'
                                            }
                                        />
                                    </li>
                                    <li>
                                        <label htmlFor="REPEAT_COUNT">{G.t('trem.lang.home.0094')}</label>{/* 시험횟수 */}
                                        <input
                                            title="시험횟수 입력"
                                            type="number"
                                            id="REPEAT_COUNT"
                                            name="REPEAT_COUNT"
                                            min="0"
                                            value={paramData.REPEAT_COUNT}
                                            onChange={handleChangeData}
                                            readOnly={
                                                equipOperInfo.CHARGE_TYPE === '01' ||
                                                equipOperInfo.CHARGE_TYPE === '02'
                                            }
                                        />
                                    </li>
                                </Fragment>
                                )}
                                <li className="hidden">
                                    <label htmlFor="REPEAT_AREA_COUNT">{G.t('trem.lang.home.0594')}</label> {/* 칸수 */}
                                    <input
                                        title="칸수 입력"
                                        type="number"
                                        name="REPEAT_AREA_COUNT"
                                        id="REPEAT_AREA_COUNT"
                                        min="0"
                                        value={paramData.REPEAT_AREA_COUNT}
                                        onChange={handleChangeData}
                                        readOnly={true}
                                    />
                                </li>
                                <li>
                                    <div className="option_box">
                                        <div className="e_option" role="group">
                                            {equipOperInfo.FLAG_SELF_USE != 'N' && (
                                                <InputBookingType
                                                    val="SU"
                                                    nm={G.t('trem.lang.home.0268')}
                                                />
                                            )}
                                            {equipOperInfo.FLAG_EXPERT == 'Y' && (
                                                <InputBookingType
                                                    val="EX"
                                                    nm={G.t('trem.lang.home.0080')}/* 일반이용(with전문가) */
                                                />
                                            )}
                                            {equipOperInfo.FLAG_REQ != 'N' && (
                                                <InputBookingType
                                                    val="RE"
                                                    nm={G.t('trem.lang.home.0078')}/* 이용의뢰 */
                                                />
                                            )}
                                            {equipOperInfo.FLAG_WITH_EDU != 'N' &&
                                                eduList &&
                                                eduList.length > 0 && (
                                                    <Fragment>
                                                        <InputBookingType
                                                            val="WE"
                                                            nm={G.t('trem.lang.home.0079')}/* 교육병행의뢰 */
                                                        />
                                                        <InputBookingType
                                                            val="WU"
                                                            nm={G.t('trem.lang.home.0081')}/* 교육병행이용 */
                                                        />
                                                        <select
                                                            name="UA_EDU_SKEY"
                                                            title="대분류 구분"
                                                            onChange={handleChangeData}
                                                            value={paramData.UA_EDU_SKEY || ''}
                                                            disabled={
                                                                paramData.BOOKING_TYPE != 'WE' &&
                                                                paramData.BOOKING_TYPE != 'WU'
                                                            }
                                                        >
                                                            <option value="">
                                                                {G.t('trem.lang.home.0757')} {/* 병행교육선택 */}
                                                            </option>
                                                            {eduList.map((obj, index) => {
                                                                return (
                                                                    <option
                                                                        key={index}
                                                                        value={obj.UA_EDU_SKEY}
                                                                    >
                                                                        {obj.EVENT_NAME}
                                                                    </option>
                                                                )
                                                            })}
                                                        </select>
                                                    </Fragment>
                                                )}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="step_box">
                        <div className="step_tt">
                            <h4>
                                <span>STEP 2</span>
                                {G.t('trem.lang.home.0095')}{/* 부가서비스, 실험재료 선택 */}
                            </h4>
                        </div>
                        <EquipMro handleChangeData={handleChangeData} dataStore={dataStore} />
                    </div>
                    {/*특수예약*/}
                    {equipOperSpList.length > 0 && (
                        <div className="step_box">
                            <div className="step_tt">
                                <h4>
                                    <span>STEP 2-1</span>
                                    {G.t('trem.lang.home.0761')} {/* 예약 선택 */}
                                </h4>
                            </div>
                            <EquipOperSp
                                equipOperSpList={equipOperSpList}
                                spChkData={spChkData}
                                setSpChkData={fnSpChk}
                            />
                        </div>
                    )}
                    <div className="step_box">
                        <div className="step_tt">
                            <h4>
                                <span>STEP 3</span>
                                {G.t('trem.lang.home.0109')}{/* 요약 */}
                            </h4>
                        </div>
                        <div className="t_gray_box em_table">
                            <table className="t_gray step_table">
                               <caption>견적 요약 표 – 순번, 장비/서비스명, 수량, 청구단위, 단가, 할인율, 금액, 세액, 비고로 구성</caption>
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">{G.t('trem.lang.home.0110')}</th>{/* 장비/서비스명 */}
                                        <th scope="col">{G.t('trem.lang.home.0111')}</th>{/* 수량 */}
                                        <th scope="col">{G.t('trem.lang.home.0914')}<br/>{G.t('trem.lang.home.0114')}</th>{/* 청구 청구단위 */}
                                        <th scope="col">{G.t('trem.lang.home.0100')}<br/>({G.t('trem.lang.home.0781')})</th>{/* 단가(원) */}
                                        <th scope="col">{G.t('trem.lang.home.0068')}<br/>(%)</th>{/* 할인율(%) */}
                                        <th scope="col">{G.t('trem.lang.home.0102')}<br/>({G.t('trem.lang.home.0782')})</th>{/* 금액(VAT별도) */}
                                        <th scope="col">세액</th>
                                        <th scope="col">{G.t('trem.lang.home.0074')}</th>{/* 비고 */}    
                                    </tr>
                                </thead>
                                <tbody>
                                    {CHARGE_LIST && CHARGE_LIST.length > 0 ? (
                                        CHARGE_LIST.map((obj, index) => {
                                            let USE_TIME = obj.USE_TIME
                                            if (!USE_TIME || typeof USE_TIME == 'undefined') {
                                                USE_TIME = '-'
                                            } else {
                                                if (
                                                    obj.UOM === 'day' ||
                                                    (USE_TIME % 24.0 == 0 && obj.UOM === '칸')
                                                ) {
                                                    USE_TIME = USE_TIME / 24
                                                } else {
                                                    if (USE_TIME % 1.0 == 0) {
                                                        USE_TIME = Math.floor(USE_TIME)
                                                    }
                                                }
                                            }

                                            return (
                                                <Fragment>
                                                    <tr key={index}>
                                                        <td>{index+1}</td>
                                                        <td>{obj.TITLE}</td>
                                                        <td>{obj.FINAL_UOM==="시간" ? obj.USE_TIME : obj.QUENTITY}</td> {/* 수량 */}{/*obj.QUENTITY*/}
                                                        <td>{obj.FINAL_UOM}</td> {/* 단위 */}
                                                        <td className="r"> 
                                                        {
                                                            obj.NOTE === "equip" &&
                                                            equipOperInfo?.CHARGE_TYPE === '01' && 
                                                            equipOperInfo?.TIME_UNIT != '1' &&
                                                            equipOperInfo?.TIME_UNIT != '60'
                                                            ? (obj?.COST *(60 / equipOperInfo?.TIME_UNIT) || 0).toLocaleString()
                                                            : (obj?.COST).toLocaleString()
                                                        }
                                                        </td> {/* 단가 */}{/**/}
                                                        <td>{obj.DISCOUNT_RATE}</td> {/* 할인율(%) */}
                                                        <td className="r"> {(obj.EXCEPT_TAX_AMOUNT || '').toLocaleString()}</td> {/* 금액(VAT별도) */}
                                                        <td className="r"> {(obj.TAX_AMOUNT || '').toLocaleString()}</td> {/* 세액 */}
                                                        <td>{obj.DESCRIPTION}</td> {/* 비고 */}
                                                    
                                                    </tr>
                                                </Fragment>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={equipOperSpList.length > 0 ? 11 : 10}>
                                                장비 스케쥴 선택 정보를 입력해주세요.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <p className="t_reference mb-6">
                            {G.t('trem.lang.home.0121')} :{' '}{/* 총금액 :  */}
                            {(chargeData?.AMOUNT || '').toLocaleString()}{' '}
                            {G.t('trem.lang.home.0781')} (※{G.t('trem.lang.home.0782')}) {/* ~원 ※(VAT 별도) */}
                        </p>
                        <div className="text_box4">
                            {G.t('trem.lang.home.0149')}
                            {/* 현재 견적은 입력한 조건을 시스템에서 생성한 견적입니다. 실 금액은 예약시 변경 될 수 있습니다. */}
                            <br />
                            {G.t('trem.lang.home.0150')}
                            {/* 실제 견적을 원하시면 아래의 ‘견적 요청하기’ 버튼을 클릭 해주세요. */}
                            {equipOperSpList.length > 0 && <p>{G.t('trem.lang.home.0783')}</p>} {/* 특수예약 시 선택 가능한 예약 구간이 현재와 다를 수 있습니다. */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="btn_type1">
                <a href="javascript:void(0);" onClick={requestEstimateFE} className="red">
                    {G.t('trem.lang.home.0784')} {/*가견적서 출력하기 */}
                </a>
                <a href="javascript:void(0);" onClick={requestEstimateOE} className="red">
                    {G.t('trem.lang.home.0152')}
                    {/* 견적 요청하기 */}
                </a>
            </div>

            {/*popup*/}
            <div>
                <UserPopup {...userPopupProps} />
            </div>
            <div>
                <DeptPopup {...deptPopupProps} />
            </div>
            <div>
                <EstimateFEPopup {...estimateFEPopupProps} />
            </div>
            <div>
                <EstimateOEPopup {...estimateOEPopupProps} />
            </div>
            <div>
                { companyCheckPopupProps.open &&
                <ModalBox {...companyCheckPopupProps} handleClose={()=>{alert(G.t('trem.lang.home.0958'))}} buttons={companyCheckPopupButtons} width="400" height="200">
                    <div>
                        <div style={{textAlign:'center'}}>
                            <p>
                                마이페이지 회원정보에서 <br/>소속정보를 입력해 주시기바랍니다.
                            </p>
                        </div>
                    </div>
                </ModalBox>}
            </div>
        </Fragment>
    )
}
